

import React from "react";
import { FaHtml5, FaReact, FaBootstrap, FaFire } from "react-icons/fa";

const skills = [
  { name: "HTML / CSS", level: 99, icon: <FaHtml5 className="text-orange-500" />, color: "from-orange-400 to-pink-500" },
  { name: "JavaScript / React.js", level: 90, icon: <FaReact className="text-blue-400" />, color: "from-yellow-400 to-blue-500" },
  { name: "Tailwind CSS / Bootstrap", level: 85, icon: <FaBootstrap className="text-purple-500" />, color: "from-teal-400 to-purple-500" },
  { name: "Redux / Redux Toolkit / Firebase", level: 80, icon: <FaFire className="text-yellow-500" />, color: "from-purple-400 to-yellow-400" },
];

const Skills = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-gray-100 via-gray-200 to-teal-100 dark:from-gray-900 dark:via-gray-800 dark:to-teal-900">
      <div className="max-w-5xl px-4 mx-auto sm:px-6 lg:px-8">
        <h2 className="mb-12 text-3xl font-extrabold tracking-tight text-center text-gray-800 sm:text-4xl lg:text-5xl dark:text-white drop-shadow-lg">
          My Skills
        </h2>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:gap-12">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="bg-white/80 dark:bg-gray-800/80 rounded-2xl shadow-xl p-6 flex flex-col gap-4 items-center hover:scale-[1.03] transition-transform duration-300"
            >
              <div className="flex items-center gap-3">
                <span className="text-3xl md:text-4xl drop-shadow-lg">{skill.icon}</span>
                <span className="text-lg font-semibold text-gray-800 md:text-xl dark:text-gray-200">{skill.name}</span>
              </div>
              <div className="flex items-center w-full gap-3">
                <div className="flex-1 h-3 overflow-hidden bg-gray-300 rounded-full dark:bg-gray-700">
                  <div
                    className={`h-3 rounded-full bg-gradient-to-r ${skill.color} animate-skill-bar`}
                    style={{ width: `${skill.level}%`, transition: 'width 1.2s cubic-bezier(.4,2,.6,1)' }}
                  ></div>
                </div>
                <span className="text-sm md:text-base font-bold text-gray-700 dark:text-gray-300 min-w-[2.5rem] text-right">{skill.level}%</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
